import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

export default function Explore(){
  const trips = useSelector(state => state.app.trips)
  return (
    <main className="container">
      <h1>Explore Trips</h1>
      <p className="lead">Browse our popular trip plans and choose your next adventure.</p>
      <div className="grid explore-trips">
        {trips.map(t => (
          <article key={t.id} className="card">
            <div>
              <h3><Link to={`/trips/${t.slug}`}>{t.title}</Link></h3>
              <p>{t.desc} Price: {t.price}</p>
            </div>
            <Link className="btn whatsapp-light" to={`/trips/${t.slug}`}>More Details</Link>
          </article>
        ))}
      </div>
    </main>
  )
}
